exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btncsv[data-v-17badf4e] {\r\n  height: 100%;\n}\r\n", ""]);

// exports
